import { Component, OnInit } from '@angular/core';
import { PermissionStore } from '@app/@core/store/permission.store';
import { MenuItem } from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-rbac',
  templateUrl: './rbac.component.html',
  styleUrls: ['./rbac.component.scss']
})
export class RbacComponent implements OnInit {
  items: MenuItem[] = [];
  activeItem!: MenuItem;
  constructor(private permissionStore: PermissionStore) {
    // This is intentional
  }

  ngOnInit(): void {
    const permissions = this.permissionStore.state;
    this.items = [
      // {
      //   label: 'Organization',
      //   routerLink: ['organization'],
      //   visible: permissions.SETTINGS_ORG,
      //   badge: 'SETTINGS_ORG'
      // },
      {
        label: 'Policy Groups / Roles',
        routerLink: ['groups-roles'],
        visible: permissions.SETTINGS_ROL,
      },
      {
        label: 'Users',
        routerLink: ['users'],
        visible: permissions.SETTINGS_USR,
      },
      {
        label: 'Migration Summary',
        routerLink: ['migrateuser'],
        visible: permissions.SETTINGS_MIG_USR,
      },
      // {
      //   label: 'Masters',
      //   routerLink: ['masters'],
      //   visible: permissions.SETTINGS_MAS,
      //   badge: 'SETTINGS_MAS'
      // },
      {
        label: 'Permissions',
        routerLink: ['page-permissions'],
        visible: permissions.SETTINGS_PER,
      },
      {
        label: 'Page Access',
        routerLink: ['page-access/form'],
        visible: permissions.SETTINGS_PAG_ACC,
      },
      {
        label: 'Dashboards',
        routerLink: ['config-dashboard'],
        visible: permissions.SETTINGS_CON_DAS,
      }
      // {
      //   label: 'User Dashboards',
      //   routerLink: ['config-dashboard-user'],
      //   visible: true,
      //   badge: 'SETTINGS_CON_DAS_USER'
      // }
      // {
      //   label: 'Configure Settings',
      //   routerLink: ['configure-settings'],
      //   visible: permissions.SETTINGS_CON_DAS,
      //   badge: 'SETTINGS_CON_DAS'
      // }
    ];
    this.items = this.items.filter(item => item.visible);
    this.activeItem = this.items[0];
  }
}
